/* 
 * listings filter js component
 */

import _Abstract from "system/abstract"
export default class Component_BannerImageRotator extends _Abstract {
  constructor(el, options) {
    super(el, $.extend(true,{
        duration: ""
    },options), 'component')

    this.imageItems = this.$el.find(".m-hero__imgitem");
    this.checkBackgroundImageInterval = "";
    if(this.imageItems.length === 0 || this.imageItems.length === 1) {
        console.log("No images available to be used in banner image rotator");
        return;
    }
    this.initialise();
    }

    initialise() {
        let _this = this;
        this.checkBackgroundImageInterval = setInterval(function(){
            let checkBackgroundImageLoaded = true;
            for(let i=0; i<_this.imageItems.length;i++) {
                if(!$(_this.imageItems[i]).hasClass("-loaded")) {
                    checkBackgroundImageLoaded = false;
                }
            }
            if(checkBackgroundImageLoaded) {
                _this.loadAndSwapNextImage();
            }
        }, 2000)
    }

    loadAndSwapNextImage() {
        clearInterval(this.checkBackgroundImageInterval)
        let _this = this
        let initialCount = 0;
        setInterval(function(){
            $(_this.imageItems[initialCount]).addClass("-hidden").removeClass("-stacking");
            ++initialCount
            if(initialCount >= _this.imageItems.length ) {
                initialCount = 0
            }
            $(_this.imageItems[initialCount]).removeClass("-hidden").addClass("-stacking");
         }, this.options.duration);
    }
}



/** WEBPACK FOOTER **
 ** ./components/banner-image-rotator.js
 **/